const INFO = {
	main: {
		title: "Mohamed Louay Ouled Ali",
		name: "Mohamed Louay Ouled Ali",
		email: "Ouledalilouay3@gmail.com",
		logo: "../logo.jpg",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/louay-ouledali",
		linkedin: "https://www.linkedin.com/in/louay-ouledali-250936394",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Backend Developer & AI Automation Engineer",
		description:
			"I am a Computer Engineering student specializing in backend development, data engineering, and AI‑powered automation. I excel at designing scalable, modern architectures, integrating intelligent features, and building full‑stack systems aligned with real-world business and engineering needs.",
	},

	about: {
		title: "I'm Mohamed Louay Ouled Ali. I live in Tunis, Tunisia, where I build the future.",
		description:
			"I am a Computer Engineering student specializing in backend development, data engineering, and AI‑powered automation. I excel at designing scalable, modern architectures, integrating intelligent features, and building full‑stack systems aligned with real-world business and engineering needs.",
		section1: {
			title: "Who I Am",
			description:
				"I am a highly motivated engineering student with strong experience in backend development, AI automation, and data engineering. I have delivered complex systems involving multi‑database orchestration, AI‑powered insights, and cloud‑ready applications. My strongest interests include AI automation & workflow engineering, Data engineering, ETL, warehousing, Backend systems & microservices, Cloud infrastructure & DevOps, and Full‑stack engineering with React & Angular.",
			images: ["whoiam1.jpg", "whoiam2.jpg"],
		},
section2: {
			title: "Education",
			description:
				"I am currently pursuing a Bachelor's in Computer Systems Engineering — Networks & Systems Specialization at ISTIC — Higher Institute of Technological Studies in Communications, expected to graduate in May 2026. My strongest academic areas include Data science subjects (17–18/20), Networking & systems, and Software engineering & project design.",
			images: ["education1.png", "education2.png"],
		},
		section3: {
			title: "Skills",
			description:
				"My technical toolkit includes Python, Java, TypeScript, JavaScript, SQL, C++, C# for programming. I work with Spring Boot, FastAPI, Flask, Angular, React frameworks. In AI/ML, I utilize Mistral 7B, Gensim (LDA), scikit-learn, PyTorch, RAG pipelines, and N8n workflow automation. For databases, I use SQL Server, PostgreSQL, MySQL, Oracle, MongoDB. My DevOps stack includes Docker, Docker Compose, Redis, RabbitMQ, Azure.",
			images: ["skills1.png", "skills2.png"],
		},
		section4: {
			title: "Certifications & Languages",
			description:
				"I hold certifications in CEH (Certified Ethical Hacker), PL‑300: Power BI Data Analyst, Scrum Master, and Python Programming. I am fluent in English (C1 — IELTS 7.5), French (B2 — DELF), and Arabic (Native).",
			images: ["certifications1.png", "certifications2.png"],
		},
	},

	certifications: [
		{
			name: "Certified Ethical Hacker (CEH)",
			issuer: "EC-Council",
			date: "2023",
			image: "https://upload.wikimedia.org/wikipedia/commons/6/60/EC-Council_logo.png"
		},
		{
			name: "Microsoft Certified: Power BI Data Analyst Associate",
			issuer: "Microsoft",
			date: "2023",
			image: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
		},
		{
			name: "Professional Scrum Master I",
			issuer: "Scrum.org",
			date: "2023",
			image: "https://upload.wikimedia.org/wikipedia/commons/5/5d/Scrum_Alliance_logo.png"
		}
	],

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Dynamic Database Connector",
			description:
				"A unified AI‑powered platform that manages, analyzes, and processes data from multiple heterogeneous database engines.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/java/java.png",
			linkText: "View Project",
			link: "https://github.com/louay-ouledali",
			longDescription: "This flagship internship project is a unified AI‑powered platform that manages, analyzes, and processes data from multiple heterogeneous database engines (MySQL, PostgreSQL, SQL Server, Oracle). It features a centralized connection manager, AI‑assisted log analysis using topic modeling + LLM reasoning, event-driven architecture with real-time ingestion, and cross-database query execution.",
			technologies: ["Spring Boot", "Angular", "Docker", "RabbitMQ", "Redis", "Python", "Mistral 7B"],
			images: [
				"dynamic-database-connector--loginscreen.png",
				"dynamic-database-connector--connection-config.png",
				"dynamic-database-connector-connection-config-preview.png",
				"dynamic-database-connector-db-status-preview-get-all-servers.png",
				"dynamic-database-connector--db-transfer-(admin-only)-transfer.png",
				"dynamic-database-connector--error-management.png",
				"dynamic-database-connector-error-log.png",
				"insights-tab-powerbi-service.png"
			],
			status: "released",
			releaseDate: "",
			expectedReleaseDate: "",
		},

		{
			title: "Modern React Portfolio",
			description:
				"A modern and expandable portfolio website built with React and advanced UI/UX libraries, featuring automatic GitHub ingestion and cloud-ready deployment.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/louay-ouledali",
			longDescription: "A modern and expandable portfolio website built with React and advanced UI/UX libraries. It features automatic ingestion of GitHub repositories, fully responsive design with modern components, Tailwind/Framer Motion UI animations, and a cloud‑ready deployment structure for Azure Static Web Apps.",
			technologies: ["React", "Tailwind", "Framer Motion", "Azure"],
			images: [
				"pholio.png",
				"pholio2.png",
				"PHOLIO3.png"
			],
			status: "released",
			releaseDate: "",
			expectedReleaseDate: "",
		},

		{
			title: "Data Warehouse for Log Analytics",
			description:
				"Designed fact/dimension tables and ETL pipelines for log processing, building dashboards for insight extraction using SQL, DAX, and Power BI.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/louay-ouledali",
			longDescription: "Designed fact/dimension tables and ETL pipelines for log processing. Built dashboards for insight extraction using SQL, DAX, and Power BI. This project demonstrates strong data engineering and business intelligence skills.",
			technologies: ["SQL", "DAX", "ETL", "Power BI"],
			status: "released",
			releaseDate: "",
			expectedReleaseDate: "",
		},

		{
			title: "N8n Automation Pipelines",
			description:
				"Automated API synchronization workflows and trigger-based pipelines for data validation and cleaning, ensuring full automation around multi-source data integration.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/louay-ouledali",
			longDescription: "Automated API synchronization workflows and trigger-based pipelines for data validation and cleaning. This project focuses on full automation around multi-source data integration using N8n.",
			technologies: ["N8n", "API", "Automation"],
			status: "released",
			releaseDate: "",
			expectedReleaseDate: "",
		},

		{
			title: "DB Router",
			description: "Intelligent database rerouting and migration automation platform with smart caching and real-time failover capabilities.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/go/go.png",
			linkText: "Coming Soon",
			link: "https://github.com/louay-ouledali",
			longDescription: "DB Router is an enterprise-grade database routing and migration automation platform. Features include automated schema migration, intelligent query routing, distributed caching with Redis, real-time failover, and performance analytics. Supports MySQL, PostgreSQL, SQL Server, and Oracle.",
			technologies: ["Go", "PostgreSQL", "Redis", "Docker", "Kubernetes", "gRPC", "Prometheus", "Grafana"],
			status: "upcoming",
			releaseDate: "",
			expectedReleaseDate: "January 2026",
		},
		{
			title: "SecConfig Auditor",
			description: "Security configuration auditing dashboard that analyzes system configs against CIS/NIST benchmarks, detects misconfigurations, and generates remediation reports.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "Coming Soon",
			link: "https://github.com/louay-ouledali",
			longDescription: "SecConfig Auditor is a comprehensive security configuration auditing platform - a linting tool for security configurations. Features include configuration import engine, benchmark mapping (CIS, NIST, DISA STIGs), misconfiguration detection with severity classification, and PDF/HTML reporting with remediation steps.",
			technologies: ["Python", "FastAPI", "React", "PostgreSQL", "Redis", "Docker", "Celery", "OpenAI API"],
			status: "upcoming",
			releaseDate: "",
			expectedReleaseDate: "May 2026",
		},
	],

	works: [
		{
			company: "MS Solutions Tunisia",
			role: "Software Engineering Intern",
			duration: "July 2025 - August 2025",
			period: "2 Months",
			logo: "https://logo.clearbit.com/mssolutions-group.com",
			achievements: [
				"Engineered a containerized multi‑database platform supporting MySQL, PostgreSQL, SQL Server, and Oracle.",
				"Built Spring Boot REST APIs with JWT + RBAC authentication.",
				"Implemented AI-driven log classification using Python, Gensim LDA, and Mistral 7B.",
				"Developed an event‑driven backend pipeline using RabbitMQ + Redis with sub‑200ms response time.",
				"Deployed Power BI dashboards for real‑time analytics and monitoring."
			],
			technologies: [
				"Spring Boot",
				"Angular",
				"Docker",
				"RabbitMQ",
				"Redis",
				"Python",
				"Mistral 7B",
				"Power BI"
			],
			link: "https://www.mssolutions-group.com/"
		}
	],
};

export default INFO;
